var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',[_c('p',{staticClass:"he-wrap-content"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}}),(_vm.showIcon)?_c('fai',{attrs:{"icon":_vm.showIcon}}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }